import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface NxtWaveLogoWhiteProps {
  width?: string;
  height?: number;
}
const NxtWaveLogoWhite: React.FC<NxtWaveLogoWhiteProps> = ({
  width = 82,
  height = 48,
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)" fill="#fff">
        <path d="M64.678 26.38h-7.834a3.198 3.198 0 0 0-3.199 3.206v10.551a3.202 3.202 0 0 0 3.198 3.206h7.835a3.198 3.198 0 0 0 3.198-3.206V29.579a3.192 3.192 0 0 0-3.198-3.198Zm-.23 5.255h-4.902v1.89h4.664v2.285h-4.664v2.271h4.902v2.264H57.08V29.371h7.374v2.264h-.007ZM31.314 26.38H28.52l-7.051 16.955h4.161l1.093-2.867h6.375l1.092 2.867h4.162l-7.037-16.954Zm-3.263 10.58 1.876-4.887 1.847 4.887h-3.723ZM52.085 26.38l-6.813 16.956h-2.796L35.641 26.38h4.212l4.032 10.608 3.967-10.608h4.233ZM22.079 29.515 18.385 41.56a2.514 2.514 0 0 1-2.408 1.776h-.021a2.512 2.512 0 0 1-2.387-1.726l-2.098-6.317c-.194-.59-1.028-.59-1.222 0l-2.12 6.325a2.513 2.513 0 0 1-2.386 1.718 2.521 2.521 0 0 1-2.408-1.783L0 32.683h2.566c.84 0 1.588.554 1.825 1.367l.54 2.098c.359 1.222 2.033 1.359 2.58.209L8.725 31.7a2.233 2.233 0 0 1 2.128-1.539c.963 0 1.818.618 2.12 1.531l1.25 4.693c.561 1.136 2.228 1 2.58-.222l1.654-7.612-1.812-.481 5.046-4.097 2.343 6.059-1.955-.517ZM14.109 4v16.955h-3.917L3.817 10.569v10.386H0V4h3.896l6.396 10.335V4h3.817ZM27.505 4 24.33 9.16l.035.058.015.021.395.647 1.085 1.653.654.985L32.056 4h-4.55ZM26.514 12.546l-1.761 2.745v-.007l-.266.424-.18.28 3.177 4.967h4.57l-5.54-8.41ZM37.797 7.5h-4.959V4h13.764v3.5h-4.938v13.455h-3.867V7.5Z" />
        <path d="M26.514 12.524v.021l.007-.014-.007-.007ZM24.444 11.54 23.35 9.885l-.395-.647-.014-.021L19.729 4h-4.571l4.564 7.03.977 1.508-1.128 1.718-4.392 6.699h4.579l1.042-1.653.158-.252 2.106-3.342.266-.424.007.007 1.76-2.76-.653-.992Z" />
        <path
          opacity={0.25}
          d="M27.505 4 24.33 9.16l.035.058.015.021.395.647 1.085 1.653.654.985L32.056 4h-4.55ZM26.514 12.546l-1.761 2.745v-.007l-.266.424-.18.28 3.177 4.967h4.571l-5.541-8.41ZM18.457 28.552l3.622.963-1.351 4.413-3.242-.906.97-4.47ZM41.664 7.5h-3.867v4.68h3.867V7.5ZM10.292 14.335l3.816 6.225V8.535l-3.816 1.373v4.427ZM3.816 10.648 0 4.424v12.031l3.816-1.372v-4.435ZM26.715 40.46l1.337-3.5h3.723l1.315 3.5h-6.375ZM43.885 36.99l1.92 5.03 3.449-8.596-2.968-2.846-2.401 6.411Z"
        />
        <path d="M71.818 39.24v-.87h4.098v.87h-1.528v4.12h-1.043v-4.12h-1.527ZM76.59 38.37h1.302l1.374 3.352h.059l1.374-3.352H82v4.99h-1.023v-3.248h-.042l-1.291 3.223h-.697L77.656 40.1h-.042v3.26h-1.023v-4.99Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(0 4)" d="M0 0h82v39.457H0z" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);

export { NxtWaveLogoWhite };
